module.exports = __webpack_public_path__ + "img/R4.92d08b9b.png";